import React from 'react';

export default function SaasContainer({ children, className = '' }) {
  return (
    <div className={`max-w-page mx-auto w-full px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
}
